module.exports = __webpack_public_path__ + "static/media/easy-distribution.94d948ab.svg";